import React from 'react';
import styles from './InitialAccountManagementRecordSelect.module.css';
import AccountManagementRecordSelect from '../../../base/components/AccountManagementRecordSelect/AccountManagementRecordSelect';

// onLogout
export default ({
  accountManagement,
  setSelectedAccountManagementRecord,
  isAdmin
}) => (
  <div className={styles.container}>
    <div className={styles.containerBackground} />
    <div className={styles.popup}>
      <div className={styles.title}>Welcome!</div>
      <div className={styles.description}>
        You have access to multiple teams. Please select the team you wish to
        access from the dropdown menu below. You can modify this selection at
        any time in the top right corner of your screen.
      </div>
      <div className={styles.pickerContainer}>
        <AccountManagementRecordSelect
          accountManagement={accountManagement}
          onSelect={setSelectedAccountManagementRecord}
          isAdmin={isAdmin}
          hideInfoText
        />
        {/*
            <div
              className={styles.logoutContainer}
              onClick={() => onLogout()}
              role="presentation"
            >
              Logout
            </div>
            */}
      </div>
    </div>
  </div>
);
